module.exports = __webpack_public_path__ + "static/hallway3-0959cada4696bea54139cf4954b1e542.jpg";